export const PAGE_LIMIT = 100;


// WEBPACK FOOTER //
// ./src/scenes/BidderCtr/config.js